'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isItemGroupComponent = (item) => {
    const items = item.items;
    return items !== undefined && items.length > 0;
};

exports.isItemGroupComponent = isItemGroupComponent;
//# sourceMappingURL=survey-item-component.js.map
